<template>
  <div class="service">
    <Banner :banners="['images/banner.png']"></Banner>
    <div class="list-img">
      <img class="img0" src="../assets/service-1.png" alt="" />
      <p class="title-info">
        亲爱的朋友,您好!
        如果您需要咨询人才相关政策，或需要对接联系我区企事业单位，您可致电：
      </p>
      <ul>
        <li>
          <div class="list-circle">
            <p></p>
            <span>应届生补贴</span>
          </div>
          <p class="number">0571-82836875</p>
        </li>
        <li>
          <div class="list-circle">
            <p></p>
            <span>毕业生就业</span>
          </div>
          <p class="number">0571-82377128</p>
        </li>
        <li>
          <div class="list-circle">
            <p></p>
            <span>萧山人才网</span>
          </div>
          <p class="number">0571-82658306</p>
        </li>
      </ul>
      <div class="qrcode">
        <img class="qrcode1" src="../assets/qrcode-1.png" alt="" />
        <img src="../assets/qrcode-2.png" alt="" />
      </div>
      <p class="bottom-words">扫码立即关注公众号</p>
    </div>
    <BackHome />
  </div>
</template>

<script>
// import Icon from '@/components/Icon'
import Banner from "../components/Banner.vue";
import BackHome from "@/components/BackHome";
export default {
  name: "Company",
  data() {
    return {};
  },
  components: {
    BackHome,
    Banner,
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  margin: 0 auto;
}
.service {
  height: 100vh;
  background: #edf2fa;
}
.list-img {
  padding-bottom: 50px;
}
.img0 {
  width: 254px;
  margin-top: 59px;
}
.title-info {
  color: #1a3965;
  font-size: 24px;
  font-weight: bold;
  margin: 56px auto;
  text-align: left;
  padding: 0 35px;
  line-height: 36px;
}
ul {
  width: 230px;
  margin: 50px auto;
}
.list-circle {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.list-circle span {
  color: #1a3965;
  font-size: 24px;
  font-weight: bold;
  margin-left: 22px;
}
.list-circle p {
  width: 16px;
  height: 16px;
  background: linear-gradient(0deg, #189eb8 0%, #346aa6 100%);
  border-radius: 50%;
}
.number {
  color: #2090b2;
  font-size: 24px;
  margin: 23px 0 45px 34px;
}
.qrcode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.qrcode img{
  width: 208px;
}
.qrcode1 {
  margin-right: 90px;
}
.bottom-words {
  color: #333;
  font-size: 18px;
  text-align: center;
  margin-top: 50px;
}
</style>